import { render } from "./TeamMembersPage.vue?vue&type=template&id=7e271c0b&ts=true"
import script from "./TeamMembersPage.vue?vue&type=script&lang=ts"
export * from "./TeamMembersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__